module.exports = __webpack_public_path__ + "static/media/jon.cd753ec5.jpg";